export default {
  ru: {
    text: {
      caption: {
        404: 'Страница, которую вы ищете, не существует либо устарела.',
        500: 'Сайт временно не доступен',
      },
      description: {
        404: 'Вы можете перейти в один из разделов сайта или вернуться на начальную страницу',
        500: 'Мы уже знаем о проблеме и работаем над её решением',
      },
    },
    button: 'Начальная страница',
  },
  en: {
    text: {
      caption: {
        404: 'Page not found',
        500: 'Site is currently not available',
      },
      description: {
        404: 'You can choose other page of website, or just go to start page',
        500: 'We know about the problem and trying to fix it',
      },
    },
    button: 'Start page',
  },
}
